/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown>, count: NonNullable<unknown> }} Summarypeakline2Inputs */

const en_summarypeakline2 = /** @type {(inputs: Summarypeakline2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Busiest at ${i?.time}: ${i?.count} in the Live Room at once.`)
};

const de_summarypeakline2 = /** @type {(inputs: Summarypeakline2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Am vollsten war es um ${i?.time}: ${i?.count} gleichzeitig im Live Room.`)
};

/**
* | output |
* | --- |
* | "Busiest at {time}: {count} in the Live Room at once." |
*
* @param {Summarypeakline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarypeakline2 = /** @type {((inputs: Summarypeakline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarypeakline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarypeakline2(inputs)
	return de_summarypeakline2(inputs)
});
export { summarypeakline2 as "summaryPeakLine" }